module.exports = __webpack_public_path__ + "img/be4ae18.svg";